import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Panel from '../../../../components/angle/Panel/index';
import Select from '../../../../components/Select/index';
import { formInputValidation } from '../../../../services/helper/form-helper';

class ClassSearchPanel extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            clientId: '',
            searchPhrase: ''
        };
    }
    componentDidMount() {
        let { user } = this.props;
        if (user && user.roleName === 'User') {
            this.setState({
                clientId: user.clientId
            });
        }
    }

    handleSelectChange = (name, value) => {
        this.setState({
            [name]: value ? value[name] : ''
        });
    };

    handleInputChange = event => {
        const target = event.target;
        const value =
            target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value ? value : ''
        });
    };

    onSearch = () => {
        let { onSearchClick } = this.props;
        let { searchPhrase, clientId } = this.state;
        if (formInputValidation(this.formRef.current)) {
            onSearchClick(searchPhrase, clientId);
        }
    };
    render() {
        let { clientList, user } = this.props;
        let { clientId, searchPhrase } = this.state;
        let viewButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSearch}
            >
                Search
            </button>
        );
        const buttonList = [viewButton];

        return (
            <Panel
                showFooter
                footerComponents={buttonList}
                panelStyle="panel-default m0"
            >
                <form ref={this.formRef}>
                    <div className="row">
                        <div className="col-md-6 mb">
                            <Select
                                name="clientId"
                                placeholder="Choose a Client"
                                labelKey="name"
                                valueKey="clientId"
                                selectedValue={clientId}
                                onChange={this.handleSelectChange}
                                options={clientList}
                                required={true}
                                disabled={
                                    user && user.roleName !== 'Administrator'
                                }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-6 mb0">
                            <input
                                className="form-control"
                                type="text"
                                name="searchPhrase"
                                placeholder="Search classes by name, ticker, cusip and client code"
                                title="Search keyword in class name, ticker, cusip and client code"
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        this.onSearch(event);
                                    }
                                }}
                                value={searchPhrase}
                                onChange={this.handleInputChange}
                                data-parsley-minlength="2"
                                required={true}
                            />
                        </div>
                    </div>
                </form>
            </Panel>
        );
    }
}

ClassSearchPanel.propTypes = {
    user: PropTypes.object.isRequired,
    clientList: PropTypes.array.isRequired,
    onSearchClick: PropTypes.func.isRequired
};

export default ClassSearchPanel;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/QuickFilingRequest/ClassSearchPanel.js